import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SmoothScroll } from "./components/site/SmoothScroll";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { WhatsAppFloat } from "./components/site/WhatsAppFloat";
import Home from "./pages/Home";
import Destinos from "./pages/Destinos";
import Pasajes from "./pages/Pasajes";
import PuntoEnvio from "./pages/PuntoEnvio";
import Contacto from "./pages/Contacto";
import Agencias from "./pages/Agencias";
import AdminLogin from "./pages/AdminLogin";
import AdminMensajes from "./pages/AdminMensajes";
import AdminAgencias from "./pages/AdminAgencias";
import AdminTrafico from "./pages/AdminTrafico";
import AdminManifiesto from "./pages/AdminManifiesto";
import AdminPasaje from "./pages/AdminPasaje";
import AdminDevolucion from "./pages/AdminDevolucion";
import AdminPresupuesto from "./pages/AdminPresupuesto";
import Presupuesto from "./pages/Presupuesto";
import AdminFlota from "./pages/AdminFlota";
import AdminCargas from "./pages/AdminCargas";
import Conductor from "./pages/Conductor";
import PagoResultado from "./pages/PagoResultado";
import MiPasaje from "./pages/MiPasaje";
import Cuenta from "./pages/Cuenta";
import RutaPasaje from "./pages/RutaPasaje";
import Legal from "./pages/Legal";
import AdminReportes from "./pages/AdminReportes";
import Arrepentimiento from "./pages/Arrepentimiento";
import { PageSeo } from "./components/site/PageSeo";
import { AuthProvider } from "./lib/auth";
import { OfflineTickets } from "./components/site/OfflineTickets";


const BARE = ["/conductor", "/admin/manifiesto/", "/admin/pasaje/", "/admin/devolucion/", "/admin/presupuesto/", "/mi-pasaje/"];
const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  if (BARE.some((p) => pathname.startsWith(p))) return null;
  return <div className="print:hidden">{children}</div>;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
      <BrowserRouter>
        <SmoothScroll />
        <PageSeo />
        <Chrome><Header /></Chrome>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/destinos" element={<Destinos />} />
            <Route path="/pasajes" element={<Pasajes />} />
            <Route path="/pasajes/:slug" element={<RutaPasaje />} />
            <Route path="/puntoenvio" element={<PuntoEnvio />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/agencias" element={<Agencias />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/mensajes" element={<AdminMensajes />} />
            <Route path="/admin/ventas" element={<AdminReportes />} />
            <Route path="/admin/agencias" element={<AdminAgencias />} />
            <Route path="/admin/trafico" element={<AdminTrafico />} />
            <Route path="/admin/manifiesto/:id" element={<AdminManifiesto />} />
            <Route path="/admin/pasaje/:id" element={<AdminPasaje />} />
            <Route path="/admin/devolucion/:id" element={<AdminDevolucion />} />
            <Route path="/admin/presupuesto/:id" element={<AdminPresupuesto />} />
            <Route path="/presupuesto/:token" element={<Presupuesto />} />
            <Route path="/admin/flota" element={<AdminFlota />} />
            <Route path="/admin/cargas" element={<AdminCargas />} />
            <Route path="/conductor" element={<Conductor />} />
            <Route path="/pago/resultado" element={<PagoResultado />} />
            <Route path="/mi-pasaje/:code" element={<MiPasaje />} />
            <Route path="/cuenta" element={<Cuenta />} />
            <Route path="/terminos-y-condiciones" element={<Legal />} />
            <Route path="/politica-de-privacidad" element={<Legal />} />
            <Route path="/cambios-y-devoluciones" element={<Legal />} />
            <Route path="/arrepentimiento" element={<Arrepentimiento />} />
          </Routes>
        </main>
        <Chrome><Footer /><WhatsAppFloat /></Chrome>
        <Toaster position="top-center" richColors />
        <OfflineTickets />
      </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
